<section class="bg-white px-4 py-8 sm:px-6 lg:px-10">
  <div
    class="mx-auto w-full max-w-screen-2xl rounded-2xl border border-zinc-200 bg-[#f4f4f4] p-2 shadow-[0_24px_60px_rgba(0,0,0,0.22)] sm:p-3">
    <div class="grid grid-cols-1 overflow-hidden rounded-xl lg:grid-cols-12">
      <aside
        class="relative col-span-1 flex min-h-[420px] flex-col justify-between overflow-hidden bg-black px-6 py-8 text-white sm:px-8 sm:py-10 lg:col-span-5 lg:min-h-[680px]">
        <div>
          <h2 class="text-3xl font-semibold tracking-tight lg:text-5xl">Contact Information</h2>
          <p class="mt-3 text-base text-zinc-300">Say something to start a live chat!</p>
        </div>

        <div class="mt-10 space-y-7">
          <div class="flex items-start gap-4 text-zinc-100">
            <svg class="mt-1 h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="M22 16.92V21a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.2 20.8 19.5 19.5 0 0 1 3.2 12.8 19.79 19.79 0 0 1 1 4.18 2 2 0 0 1 3 2h4.09a2 2 0 0 1 2 1.72 12.79 12.79 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.1 9.91a16 16 0 0 0 6 6l1.27-1.24a2 2 0 0 1 2.11-.45 12.79 12.79 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <span class="text-lg font-medium sm:text-xl">+44 8568925487</span>
          </div>

          <div class="flex items-start gap-4 text-zinc-100">
            <svg class="mt-1 h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v.2L12 13 2 5.2V5Zm0 2.7V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7.7l-9.4 7.1a1 1 0 0 1-1.2 0L2 7.7Z" />
            </svg>
            <span class="text-lg font-medium sm:text-xl">contact@safeword.com</span>
          </div>

          <div class="flex items-start gap-4 text-zinc-100">
            <svg class="mt-1 h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2a8 8 0 0 0-8 8c0 6 8 12 8 12s8-6 8-12a8 8 0 0 0-8-8Zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
            </svg>
            <span class="max-w-xs text-lg leading-snug font-medium sm:text-xl">
              12a Marlborough Place<br>
              Brighton BN1 1WN<br>
              United Kingdom
            </span>

          </div>
        </div>

        <div class="relative z-10 mt-10 flex gap-3">
          <button type="button"
            class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-900 text-white ring-1 ring-zinc-700 transition hover:bg-zinc-800"
            aria-label="Twitter">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M22 5.8c-.7.3-1.5.5-2.3.6a4 4 0 0 0 1.8-2.2 8.3 8.3 0 0 1-2.6 1A4.1 4.1 0 0 0 12 8a11.7 11.7 0 0 1-8.5-4.3A4 4 0 0 0 4.8 9a4 4 0 0 1-1.9-.5v.1A4.1 4.1 0 0 0 6.2 13a4.1 4.1 0 0 1-1.9.1A4.1 4.1 0 0 0 8.1 16 8.3 8.3 0 0 1 2 17.8 11.8 11.8 0 0 0 8.4 19.7c7.7 0 12-6.4 12-11.9v-.5c.8-.6 1.4-1.2 1.9-2Z" />
            </svg>
          </button>
          <button type="button"
            class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-900 text-white ring-1 ring-zinc-700 transition hover:bg-zinc-800"
            aria-label="Instagram">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm0 1.8A4 4 0 0 0 3.8 7.8v8.4a4 4 0 0 0 4 4h8.4a4 4 0 0 0 4-4V7.8a4 4 0 0 0-4-4H7.8Zm8.8 1.3a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.8A3.2 3.2 0 1 0 12 15.2 3.2 3.2 0 0 0 12 8.8Z" />
            </svg>
          </button>
          <button type="button"
            class="inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-900 text-white ring-1 ring-zinc-700 transition hover:bg-zinc-800"
            aria-label="Discord">
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M20.3 4.4A17 17 0 0 0 16 3a12.6 12.6 0 0 0-.6 1.3A16 16 0 0 0 8.6 4.3 13.7 13.7 0 0 0 8 3a17 17 0 0 0-4.3 1.4C1 8.1.2 11.7.6 15.3A17.2 17.2 0 0 0 5.8 18c.4-.6.8-1.2 1.1-1.8-.6-.2-1.2-.5-1.8-.8l.4-.3a11.5 11.5 0 0 0 13 0l.4.3c-.6.3-1.2.6-1.8.8.3.6.7 1.2 1.1 1.8a17.2 17.2 0 0 0 5.2-2.7c.5-4.2-.8-7.8-3.1-10.9ZM9.6 13.3c-1 0-1.8-.9-1.8-2s.8-2 1.8-2c1.1 0 1.9.9 1.8 2 0 1.1-.8 2-1.8 2Zm4.8 0c-1 0-1.8-.9-1.8-2s.8-2 1.8-2 1.9.9 1.8 2c0 1.1-.8 2-1.8 2Z" />
            </svg>
          </button>
        </div>

        <div class="pointer-events-none absolute -right-10 bottom-8 h-52 w-52 rounded-full bg-zinc-700/20"></div>
        <div class="pointer-events-none absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-zinc-600/20"></div>
      </aside>

      <div class="col-span-1 bg-[#f4f4f4] px-5 py-7 sm:px-8 sm:py-9 lg:col-span-7 lg:px-12 lg:py-12">
        <form class="h-full">
          <div class="grid grid-cols-1 gap-x-8 gap-y-7 sm:grid-cols-2">
            <label class="block">
              <span class="text-sm text-zinc-400">First Name</span>
              <input type="text" value="" placeholder="Please enter your first name"
                class="mt-2 w-full border-0 border-b border-zinc-300 bg-transparent px-0 py-2 text-lg text-zinc-900 outline-none placeholder:text-zinc-400 focus:border-zinc-600" />
            </label>

            <label class="block">
              <span class="text-sm font-semibold text-zinc-900">Last Name</span>
              <input type="text" value="" placeholder="Please enter your last name"
                class="mt-2 w-full border-0 border-b border-zinc-400 bg-transparent px-0 py-2 text-lg text-zinc-900 outline-none placeholder:text-zinc-400 focus:border-zinc-600" />
            </label>

            <label class="block">
              <span class="text-sm text-zinc-400">Email</span>
              <input type="email" value="" placeholder="Please enter your email"
                class="mt-2 w-full border-0 border-b border-zinc-300 bg-transparent px-0 py-2 text-lg text-zinc-900 outline-none placeholder:text-zinc-400 focus:border-zinc-600" />
            </label>

            <label class="block">
              <span class="text-sm font-semibold text-zinc-900">Phone Number</span>
              <input type="tel" value="" placeholder="Please enter your phone number"
                class="mt-2 w-full border-0 border-b border-zinc-400 bg-transparent px-0 py-2 text-lg text-zinc-900 outline-none placeholder:text-zinc-400 focus:border-zinc-600" />
            </label>
          </div>

          <div class="mt-10">
            <p class="text-xl font-semibold text-zinc-900 sm:text-2xl">Select Subject?</p>
            <div class="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
              <label class="inline-flex cursor-pointer items-center gap-3">
                <input name="subject" type="radio" checked class="h-4 w-4 accent-black" />
                <span class="text-base text-zinc-900">General Inquiry</span>
              </label>
              <label class="inline-flex cursor-pointer items-center gap-3">
                <input name="subject" type="radio" class="h-4 w-4 accent-black" />
                <span class="text-base text-zinc-900">Being Partner Inquiry</span>
              </label>
            </div>
          </div>

          <label class="mt-10 block">
            <span class="text-lg text-zinc-400 sm:text-xl">Message</span>
            <textarea rows="2" placeholder="Write your message.."
              class="mt-3 w-full resize-none border-0 border-b border-zinc-300 bg-transparent px-0 py-2 text-lg text-zinc-900 outline-none placeholder:text-zinc-400 focus:border-zinc-600"></textarea>
          </label>

          <div class="mt-8 flex justify-start sm:justify-end">
            <button type="submit"
              class="inline-flex min-h-[56px] w-full items-center justify-center rounded-lg bg-[#D31148] px-8 text-lg font-medium text-white shadow-lg transition sm:w-auto sm:min-w-[230px]">
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>